<template>
  <nav aria-label="breadcrumb" class="breadcrumb-wrap">
    <ol class="breadcrumb pt-0 pt-md-3 pb-3">
      <li
        class="breadcrumb-item pt-3 pt-md-0"
        :class="{ active: !data.link }"
        v-for="(data, index) in list"
        :key="index"
      >
        <router-link v-if="data.link" :to="data.link">{{
          data.title
        }}</router-link>
        <span v-else>{{ data.title }}</span>
      </li>
    </ol>
  </nav>
</template>
<script>
export default {
  name: "Breadcrumb",
  props: {
    list: {
      default: [],
    },
  },
};
</script>
